export const formatPhoneForWhatsApp = phone => {
  if (!phone) return '';
  const cleanPhone = String(phone).replace(/\D/g, '');
  const noLeadingZeros = cleanPhone.replace(/^0+/, '');
  const withoutCountryCode = noLeadingZeros.startsWith('91')
    ? noLeadingZeros.substring(2)
    : noLeadingZeros;

  if (withoutCountryCode.length === 10) return `91${withoutCountryCode}`;
  if (withoutCountryCode.length === 12 && withoutCountryCode.startsWith('91')) {
    return withoutCountryCode;
  }
  return phone;
};

export const formatPhoneForDisplay = phone => {
  if (!phone || phone.length !== 12) return phone;
  return `+${phone.substring(0, 2)} ${phone.substring(2, 7)} ${phone.substring(7, 12)}`;
};

export const formatPhoneForInput = phone => {
  if (!phone) return '';
  const cleanPhone = String(phone).replace(/\D/g, '');
  const withoutCountryCode = cleanPhone.startsWith('91') ? cleanPhone.substring(2) : cleanPhone;
  return withoutCountryCode.slice(-10);
};

export const validateIndianPhone = phone => {
  if (!phone) return false;
  const cleanPhone = String(phone).replace(/\D/g, '');
  return /^[6-9]\d{9}$/.test(cleanPhone);
};

export const getPhoneValidationError = phone => {
  if (!phone || String(phone).trim() === '') return 'Phone number is required';
  if (!validateIndianPhone(phone)) {
    return 'Invalid Indian phone number (must start with 6-9 and be 10 digits)';
  }
  return '';
};

export const formatPhoneInput = value => String(value || '').replace(/\D/g, '').slice(0, 10);

export const convertFromWhatsAppFormat = (whatsappPhone, format = 'display') => {
  if (!whatsappPhone || whatsappPhone.length !== 12) return whatsappPhone;
  if (format === 'display') return formatPhoneForDisplay(whatsappPhone);
  if (format === 'input') return formatPhoneForInput(whatsappPhone);
  if (format === 'international') return `+${whatsappPhone}`;
  return whatsappPhone;
};

export const isWhatsAppFormat = phone => {
  return Boolean(phone && phone.length === 12 && phone.startsWith('91') && /^\d+$/.test(phone));
};

export const autoFormatOnBlur = phone => {
  if (!phone) return '';
  if (isWhatsAppFormat(phone)) return phone;
  return formatPhoneForWhatsApp(phone);
};
